import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import api from '../config/api';

function Login() {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [isFirstAccess, setIsFirstAccess] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    checkFirstAccess();
  }, []);

  const checkFirstAccess = async () => {
    try {
      const response = await api.get('/admin/check-first-access');
      setIsFirstAccess(response.data.isFirstAccess);
    } catch (error) {
      console.error('Erro ao verificar primeiro acesso:', error);
      toast.error('Erro ao verificar primeiro acesso');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (isFirstAccess) {
      if (senha !== confirmarSenha) {
        setError('As senhas não coincidem');
        return;
      }
      setLoading(true);
      try {
        await api.post('/admin/first-access', {
          usuario,
          senha
        });
        toast.success('Administrador criado com sucesso');
        await login(usuario, senha);
        navigate('/');
      } catch (error) {
        console.error('Erro ao criar administrador:', error);
        setError('Erro ao criar administrador');
        toast.error('Erro ao criar administrador');
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        await login(usuario, senha);
        navigate('/');
      } catch (error) {
        setError('Usuário ou senha inválidos');
        toast.error('Erro ao fazer login');
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <Typography component="h1" variant="h5">
            {isFirstAccess ? 'Criar Primeiro Administrador' : 'WhatsBras'}
          </Typography>
          {isFirstAccess && (
            <Alert severity="info" sx={{ mt: 2, width: '100%' }}>
              Este é o primeiro acesso ao sistema. Crie um usuário administrador.
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <TextField
              margin="normal"
              required
              fullWidth
              id="usuario"
              label="Usuário"
              name="usuario"
              autoComplete="usuario"
              autoFocus
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="senha"
              label="Senha"
              type="password"
              id="senha"
              autoComplete="new-password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
            />
            {isFirstAccess && (
              <TextField
                margin="normal"
                required
                fullWidth
                name="confirmarSenha"
                label="Confirmar Senha"
                type="password"
                id="confirmarSenha"
                autoComplete="new-password"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
              />
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading
                ? 'Processando...'
                : isFirstAccess
                ? 'Criar Administrador'
                : 'Entrar'}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Login; 